import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <div className="grain-section relative w-full flex flex-col items-center justify-start pt-20 pb-32 md:pb-40 overflow-hidden bg-page-bg" data-id="element-55">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-8" data-id="element-56">
        <div className="max-w-3xl mx-auto space-y-8 text-center" data-id="element-57">
          {/* Logo */}

          {/* Headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} className="text-4xl md:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.95] mb-6 text-ink" data-id="element-58">
            What happens when you work with a{' '}
            <span className="text-teal-600" data-id="element-59">TRUE MASTER</span> of human biology?
          </motion.h1>

          {/* Subheadline */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.8
        }} className="space-y-6" data-id="element-60">
            <div className="space-y-2 text-center" data-id="element-61">
              <p className="text-base font-semibold text-teal-600 tracking-wide" data-id="element-62">
                Dr. Ali Mazloum{' '}
                <span className="font-normal text-ink-light italic" data-id="element-63">
                  ("The Human MRI")
                </span>
                <span className="mx-3 text-teal-300 font-light" data-id="element-64">|</span>
                Brenden Henry{' '}
                <span className="font-normal text-ink-light italic" data-id="element-65">
                  ("The World's #1 Authority on Peptide Science")
                </span>
              </p>
              <p className="text-xl md:text-2xl text-ink-light font-light leading-relaxed" data-id="element-66">
                Two of the Peptide Science Institute's Transformation
                Specialists who can help you do what{' '}
                <span className="font-bold text-ink" data-id="element-67">NO OTHER</span> medical
                team or elite biohacker in the world can do.
              </p>
            </div>

            <div className="grid grid-cols-1 gap-4 text-left" data-id="element-68">
              <p className="text-lg text-ink font-medium text-center" data-id="element-69">
                Whether you're:
              </p>

              {/* Card 1 */}
              <div className="relative bg-white rounded-2xl p-5 shadow-sm border border-black/5 flex items-start gap-4 overflow-hidden" data-id="element-70">
                <div className="absolute inset-0 bg-gradient-to-r from-rose-50 to-transparent opacity-60 pointer-events-none" data-id="element-71" />
                <div className="relative flex-shrink-0 w-10 h-10 rounded-xl bg-rose-100 flex items-center justify-center text-xl" data-id="element-72">
                  🩺
                </div>
                <div className="relative" data-id="element-73">
                  <p className="text-base font-semibold text-ink leading-snug" data-id="element-74">
                    Fighting to reclaim your health
                  </p>
                  <p className="text-sm text-ink-light mt-0.5 italic" data-id="element-75">
                    after conventional approaches failed you...
                  </p>
                </div>
              </div>

              {/* Card 2 */}
              <div className="relative bg-white rounded-2xl p-5 shadow-sm border border-black/5 flex items-start gap-4 overflow-hidden" data-id="element-76">
                <div className="absolute inset-0 bg-gradient-to-r from-teal-50 to-transparent opacity-60 pointer-events-none" data-id="element-77" />
                <div className="relative flex-shrink-0 w-10 h-10 rounded-xl bg-teal-100 flex items-center justify-center text-xl" data-id="element-78">
                  ⚡
                </div>
                <div className="relative" data-id="element-79">
                  <p className="text-base font-semibold text-ink leading-snug" data-id="element-80">
                    Hunting for enhancements that take you further
                  </p>
                  <p className="text-sm text-ink-light mt-0.5 italic" data-id="element-81">
                    beyond what a human can "normally" achieve...
                  </p>
                </div>
              </div>

              {/* Card 3 */}
              <div className="relative bg-white rounded-2xl p-5 shadow-sm border border-black/5 flex items-start gap-4 overflow-hidden" data-id="element-82">
                <div className="absolute inset-0 bg-gradient-to-r from-amber-50 to-transparent opacity-60 pointer-events-none" data-id="element-83" />
                <div className="relative flex-shrink-0 w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center text-xl" data-id="element-84">
                  🤝
                </div>
                <div className="relative" data-id="element-85">
                  <p className="text-base font-semibold text-ink leading-snug" data-id="element-86">
                    Determined to save someone you care about
                  </p>
                  <p className="text-sm text-ink-light mt-0.5 italic" data-id="element-87">
                    even if nothing else has worked...
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-md border border-black/5" data-id="element-88">
              <p className="text-lg text-ink leading-relaxed text-left" data-id="element-89">
                In a single{' '}
                <span className="font-bold" data-id="element-90">
                  "Meeting With the Master Advanced"
                </span>{' '}
                session, we'll show you{' '}
                <span className="font-bold text-teal-600" data-id="element-91">
                  EXACTLY what's wrong
                </span>
                ... and give you the exact roadmap to fix it.
              </p>
            </div>

            <div className="flex justify-center" data-id="element-92"></div>
          </motion.div>

          {/* CTA Buttons */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6,
          duration: 0.8
        }} className="flex flex-col sm:flex-row gap-4 pt-4 justify-center" data-id="element-93">
            <a href="https://go.peptidescienceinstitute.com/meeting-with-the-master-advanced" className="w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-[#1d1d1f] to-[#2d2d2f] hover:from-black hover:to-[#1a1a1c] text-white rounded-full font-semibold transition-all duration-200 shadow-sm hover:shadow-md text-center text-sm sm:text-base" data-id="element-94">
              Book Your Meeting With the Master: Advanced
            </a>
            <a href="#masters" className="w-full sm:w-auto px-8 py-4 bg-teal-600 hover:bg-teal-700 text-white rounded-full font-semibold transition-all duration-200 shadow-sm hover:shadow-md text-center" data-id="element-95">
              Meet The Experts
            </a>
          </motion.div>
        </div>
      </div>
    </div>;
}